import { render } from "./AdminPending75Liquidations.vue?vue&type=template&id=617a94c1"
import script from "./AdminPending75Liquidations.vue?vue&type=script&lang=js"
export * from "./AdminPending75Liquidations.vue?vue&type=script&lang=js"

import "./AdminPending75Liquidations.vue?vue&type=style&index=0&id=617a94c1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__